const endpoints = (mode) => {
  const projectEndpoints = {
    standard: () => ({
      principalDomain: process.env.REACT_APP_ENDPOINT_principalDomain,
      REPOSITORY_uri: process.env.REACT_APP_ENDPOINT_REPOSITORY_uri,
      XDSB_domain: process.env.REACT_APP_ENDPOINT_XDSB_domain,
      REGISTRY_uri: process.env.REACT_APP_ENDPOINT_REGISTRY_uri,
      CONSENT_api: process.env.REACT_APP_ENDPOINT_CONSENT_api,
      PIX_domain: process.env.REACT_APP_ENDPOINT_PIX_domain,
      PIXPDQ_domain: process.env.REACT_APP_ENDPOINT_PIXPDQ_domain,
      token_api: process.env.REACT_APP_ENDPOINT_token_api,
      Scim2: process.env.REACT_APP_ENDPOINT_Scim2,
      SignUPURL: process.env.REACT_APP_ENDPOINT_SignUPURL,
      dataValidatorUrl: process.env.REACT_APP_ENDPOINT_dataValidatorUrl,
      PassRecovery: process.env.REACT_APP_ENDPOINT_PassRecovery,
      OAUTH: process.env.REACT_APP_ENDPOINT_OAUTH,
      FHIR: process.env.REACT_APP_ENDPOINT_FHIR,
      APPCFHIR: process.env.REACT_APP_ENDPOINT_APPCFHIR,
      TERMINOLOGY: process.env.REACT_APP_ENDPOINT_TERMINOLOGY,
      MHD: process.env.REACT_APP_ENDPOINT_MHD,
      portalConsumerKey: process.env.REACT_APP_PORTAL_CONSUMER_KEY,
      portalConsumerSecret: process.env.REACT_APP_PORTAL_CONSUMER_SECRET,
      SignUP_c_key: process.env.REACT_APP_SIGNUP_CONSUMER_KEY,
      SignUP_c_secret: process.env.REACT_APP_SIGNUP_CONSUMER_SECRET,
      PassRecoveryBearer: process.env.REACT_APP_ENDPOINT_PassRecoveryBearer,
      IBGE_domain: process.env.REACT_APP_ENDPOINT_IBGE_domain,
      termsUri: process.env.REACT_APP_ENDPOINT_termsUri,
      MPI_FHIR: process.env.REACT_APP_ENDPOINT_MPI_FHIR,
      USER_FHIR: process.env.REACT_APP_ENDPOINT_USER_FHIR,
      ADMFHIR: process.env.REACT_APP_ENDPOINT_ADMFHIR,
      portalBasicAuth: process.env.REACT_APP_PORTAL_BASIC_AUTH,
    }),

    paciente: () => ({
      principalDomain: process.env.REACT_APP_ENDPOINT_principalDomain,
      REPOSITORY_uri: process.env.REACT_APP_ENDPOINT_REPOSITORY_uri,
      XDSB_domain: process.env.REACT_APP_ENDPOINT_XDSB_domain,
      REGISTRY_uri: process.env.REACT_APP_ENDPOINT_REGISTRY_uri,
      CONSENT_api: process.env.REACT_APP_ENDPOINT_CONSENT_api,
      PIX_domain: process.env.REACT_APP_ENDPOINT_PIX_domain,
      PIXPDQ_domain: process.env.REACT_APP_ENDPOINT_PIXPDQ_domain,
      token_api: process.env.REACT_APP_ENDPOINT_token_api,
      Scim2: process.env.REACT_APP_ENDPOINT_Scim2,
      SignUPURL: process.env.REACT_APP_ENDPOINT_SignUPURL,
      dataValidatorUrl: process.env.REACT_APP_ENDPOINT_dataValidatorUrl,
      PassRecovery: process.env.REACT_APP_ENDPOINT_PassRecovery,
      OAUTH: process.env.REACT_APP_ENDPOINT_OAUTH,
      FHIR: process.env.REACT_APP_ENDPOINT_FHIR,
      APPCFHIR: process.env.REACT_APP_ENDPOINT_APPCFHIR,
      TERMINOLOGY: process.env.REACT_APP_ENDPOINT_TERMINOLOGY,
      MHD: process.env.REACT_APP_ENDPOINT_MHD,
      portalConsumerKey: process.env.REACT_APP_PORTAL_PACIENTE_CONSUMER_KEY,
      portalConsumerSecret:
        process.env.REACT_APP_PORTAL_PACIENTE_CONSUMER_SECRET,
      SignUP_c_key: process.env.REACT_APP_SIGNUP_CONSUMER_KEY,
      SignUP_c_secret: process.env.REACT_APP_SIGNUP_CONSUMER_SECRET,
      PassRecoveryBearer: process.env.REACT_APP_ENDPOINT_PassRecoveryBearer,
      IBGE_domain: process.env.REACT_APP_ENDPOINT_IBGE_domain,
      termsUri: process.env.REACT_APP_ENDPOINT_termsUri,
      MPI_FHIR: process.env.REACT_APP_ENDPOINT_MPI_FHIR,
      USER_FHIR: process.env.REACT_APP_ENDPOINT_USER_FHIR,
      ADMFHIR: process.env.REACT_APP_ENDPOINT_ADMFHIR,
      portalBasicAuth: process.env.REACT_APP_PORTAL_BASIC_AUTH,
    }),
    profissional: () => ({
      principalDomain: process.env.REACT_APP_ENDPOINT_principalDomain,
      REPOSITORY_uri: process.env.REACT_APP_ENDPOINT_REPOSITORY_uri,
      XDSB_domain: process.env.REACT_APP_ENDPOINT_XDSB_domain,
      REGISTRY_uri: process.env.REACT_APP_ENDPOINT_REGISTRY_uri,
      CONSENT_api: process.env.REACT_APP_ENDPOINT_CONSENT_api,
      PIX_domain: process.env.REACT_APP_ENDPOINT_PIX_domain,
      PIXPDQ_domain: process.env.REACT_APP_ENDPOINT_PIXPDQ_domain,
      token_api: process.env.REACT_APP_ENDPOINT_token_api,
      Scim2: process.env.REACT_APP_ENDPOINT_Scim2,
      SignUPURL: process.env.REACT_APP_ENDPOINT_SignUPURL,
      dataValidatorUrl: process.env.REACT_APP_ENDPOINT_dataValidatorUrl,
      PassRecovery: process.env.REACT_APP_ENDPOINT_PassRecovery,
      OAUTH: process.env.REACT_APP_ENDPOINT_OAUTH,
      FHIR: process.env.REACT_APP_ENDPOINT_FHIR,
      APPCFHIR: process.env.REACT_APP_ENDPOINT_APPCFHIR,
      TERMINOLOGY: process.env.REACT_APP_ENDPOINT_TERMINOLOGY,
      MHD: process.env.REACT_APP_ENDPOINT_MHD,
      portalConsumerKey: process.env.REACT_APP_PORTAL_PROFISSIONAL_CONSUMER_KEY,
      portalConsumerSecret:
        process.env.REACT_APP_PORTAL_PROFISSIONAL_CONSUMER_SECRET,
      SignUP_c_key: process.env.REACT_APP_SIGNUP_CONSUMER_KEY,
      SignUP_c_secret: process.env.REACT_APP_SIGNUP_CONSUMER_SECRET,
      PassRecoveryBearer: process.env.REACT_APP_ENDPOINT_PassRecoveryBearer,
      IBGE_domain: process.env.REACT_APP_ENDPOINT_IBGE_domain,
      termsUri: process.env.REACT_APP_ENDPOINT_termsUri,
      MPI_FHIR: process.env.REACT_APP_ENDPOINT_MPI_FHIR,
      USER_FHIR: process.env.REACT_APP_ENDPOINT_USER_FHIR,
      ADMFHIR: process.env.REACT_APP_ENDPOINT_ADMFHIR,
      portalBasicAuth: process.env.REACT_APP_PORTAL_BASIC_AUTH,
    }),

    aghu: () => ({
      principalDomain: process.env.REACT_APP_ENDPOINT_principalDomain,
      REPOSITORY_uri: process.env.REACT_APP_ENDPOINT_REPOSITORY_uri,
      XDSB_domain: process.env.REACT_APP_ENDPOINT_XDSB_domain,
      REGISTRY_uri: process.env.REACT_APP_ENDPOINT_REGISTRY_uri,
      CONSENT_api: process.env.REACT_APP_ENDPOINT_CONSENT_api,
      PIX_domain: process.env.REACT_APP_ENDPOINT_PIX_domain,
      PIXPDQ_domain: process.env.REACT_APP_ENDPOINT_PIXPDQ_domain,
      token_api: process.env.REACT_APP_ENDPOINT_token_api,
      Scim2: process.env.REACT_APP_ENDPOINT_Scim2,
      SignUPURL: process.env.REACT_APP_ENDPOINT_SignUPURL,
      dataValidatorUrl: process.env.REACT_APP_ENDPOINT_dataValidatorUrl,
      PassRecovery: process.env.REACT_APP_ENDPOINT_PassRecovery,
      OAUTH: process.env.REACT_APP_ENDPOINT_OAUTH,
      FHIR: process.env.REACT_APP_ENDPOINT_FHIR,
      APPCFHIR: process.env.REACT_APP_ENDPOINT_APPCFHIR,
      TERMINOLOGY: process.env.REACT_APP_ENDPOINT_TERMINOLOGY,
      MHD: process.env.REACT_APP_ENDPOINT_MHD_NO_INTROSPECTION,
      portalConsumerKey: process.env.REACT_APP_PORTAL_AGHU_CONSUMER_KEY,
      portalConsumerSecret: process.env.REACT_APP_PORTAL_AGHU_CONSUMER_SECRET,
      SignUP_c_key: process.env.REACT_APP_SIGNUP_CONSUMER_KEY,
      SignUP_c_secret: process.env.REACT_APP_SIGNUP_CONSUMER_SECRET,
      PassRecoveryBearer: process.env.REACT_APP_ENDPOINT_PassRecoveryBearer,
      IBGE_domain: process.env.REACT_APP_ENDPOINT_IBGE_domain,
      termsUri: process.env.REACT_APP_ENDPOINT_termsUri,
      MPI_FHIR: process.env.REACT_APP_ENDPOINT_MPI_FHIR_NO_INTROSPECTION,
      USER_FHIR: process.env.REACT_APP_ENDPOINT_USER_FHIR,
      ADMFHIR: process.env.REACT_APP_ENDPOINT_ADMFHIR,
      portalBasicAuth: process.env.REACT_APP_PORTAL_BASIC_AUTH,
    }),
  };

  try {
    return projectEndpoints[mode]();
  } catch (err) {
    return projectEndpoints.standard();
  }
};

const features = (mode) => {
  const projectFeatures = {
    standard: () => ({
      consent: true,
      accessHistory: true,
      granted: true,
      policy: true,
      profile: true,
      reports: true,
      myReports: true,
      schedule: true,
      terms: true,
      loginWithGovBr: true,
      regularLogin: true,
      loginWithOffice365: true,
      address: true,
      partnership: true,
      searchPatients: true,
      cpfValidator: true,
      doNotGetPractitionerRoles: false,
    }),
    paciente: () => ({
      consent: true,
      policy: true,
      profile: true,
      myReports: true,
      reports: false,
      accessHistory: true,
      granted: true,
      schedule: true,
      terms: true,
      loginWithGovBr: true,
      regularLogin: true,
      loginWithOffice365: false,
      address: true,
      partnership: true,
      searchPatients: true,
      cpfValidator: true,
      doNotGetPractitionerRoles: true,
    }),
    profissional: () => ({
      consent: true,
      policy: false,
      accessHistory: false,
      granted: false,
      profile: true,
      myReports: false,
      reports: true,
      schedule: true,
      terms: true,
      loginWithGovBr: false,
      regularLogin: true,
      loginWithOffice365: true,
      address: true,
      partnership: true,
      searchPatients: true,
      cpfValidator: true,
      doNotGetPractitionerRoles: false,
    }),
    aghu: () => ({
      allowVisualizerFromURL: true,
      bypassLoginPageWithVisualizer: true,
    }),
  };

  try {
    return projectFeatures[mode]();
  } catch (err) {
    return projectFeatures.standard();
  }
};

const roles = () => ({
  ROLE_PRACTITIONER: 'isProfessional',
});

const docTypes = () => [
  {
    name: 'Todos',
    alias: '',
    codes: [''],
  },
  {
    name: 'Sumário de Alta',
    alias: 'SA',
    codes: ['SumárioAlta.v4.0'],
  },
  {
    name: 'Registro de Atendimento Clínico',
    alias: 'RAC',
    codes: [
      'RegistroAtendimentoClínico.v4.1',
      'RegistroAtendimentoClínico.v4.2',
    ],
  },
];

const languagesList = ['en', 'pt-BR'];
const initialLanguage = languagesList[1];

const oids = () => ({
  organization: '2.16.840.1.113883.13.36',
  cpf: '2.16.840.1.113883.13.237',
  cns: '2.16.840.1.113883.13.236',
  practitionerRoles: '1.3.6.1.4.1.54413.1.1.2.1',
  programHealthCareService: '1.3.6.1.4.1.54413.1.1.2.2',
  categoryHealthCareService: '1.3.6.1.4.1.54413.1.1.6.8',
  susAttendance: '1.3.6.1.4.1.54413.1.1.6.7',
  admType: '1.3.6.1.4.1.54413.1.1.6.6',
  legalNature: '1.3.6.1.4.1.54413.1.1.6.4',
  orgType: '1.3.6.1.4.1.54413.1.1.6.3',
  immunobiological: '1.3.6.1.4.1.54413.1.1.6.10',
  doseCovidVaccine: '1.3.6.1.4.1.54413.1.1.6.14',
  immunizationEffects: '1.3.6.1.4.1.54413.1.1.6.13',
  documentPdf: '1.3.6.1.4.1.54413.1.1.2.3.1',
  council: '2.16.840.1.113883.13.243',
});

const settings = {
  endpoints,
  features,
  roles,
  docTypes,
  languagesList,
  oids,
  initialLanguage,
};

export {
  settings,
  endpoints,
  features,
  roles,
  docTypes,
  languagesList,
  oids,
  initialLanguage,
};
